window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var st = ns.state;
  var resolve = ns.resolve;

  function getLocationByVenueId(venueId) {
    var found = null;
    $.each(locations, function (locationId, location) {
      if (location.venueId === venueId) {
        found = location;
        return false;
      }
    });
    return found;
  }

  function sameVenueId(a, b) {
    return parseInt(a, 10) === parseInt(b, 10);
  }

  function getRoomByEventId(venueId, eventId) {
    var cfg = ns.config;
    var rooms = [];
    var tables = [];
    // Rooms and tables can live on a different location than their IsleHelp
    // venue (Primal Fear is stored on Elgin but Radioactive is venue 300), so
    // match on each entry's own venueId, falling back to the location's.
    function collectForVenue(location, entries, into) {
      $.each(entries || [], function (i, entry) {
        var entryVenue = entry.venueId != null ? entry.venueId : location.venueId;
        if (sameVenueId(entryVenue, venueId)) {
          into.push(entry);
        }
      });
    }
    $.each(locations, function (locationId, location) {
      collectForVenue(location, location.rooms, rooms);
      collectForVenue(location, location.tables, tables);
    });
    return resolve.resolveRoomByEventId(rooms, tables, eventId, {
      preferEventRooms: !!(cfg && cfg.isLocationEvent),
      eventName: cfg && cfg.isLocationEvent ? cfg.EVENT_NAME : undefined,
    });
  }

  function resolveMinPlayersFixedPrice(room, eventId) {
    if (!room) return 0;
    eventId = parseInt(eventId, 10);
    var variants = room.eventVariants || [];
    if (variants.length > 0) {
      if (!Number.isFinite(eventId)) return 0;
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant.eventIds || $.inArray(eventId, variant.eventIds) === -1) continue;
        if (variant.minPlayersFixedPrice != null && variant.minPlayersFixedPrice !== "") {
          var n = parseInt(variant.minPlayersFixedPrice, 10);
          return Number.isFinite(n) && n > 0 ? n : 0;
        }
        return 0;
      }
      return 0;
    }
    return room.minPlayersFixedPrice || 0;
  }

  function getSelectedTimeSlot() {
    var state = st.get();
    var allDates = st.getAllDates();
    var timeSlot = {
      location: null,
      event: null,
      data: null,
    };

    var events = allDates[state.date];
    $.each(events, function (eventIndex, event) {
      if (state.event !== null && $.inArray(state.event, event.room.eventIds) > -1 && event.venue.id == state.venue) {
        timeSlot.event = event;

        if (typeof timeSlot.event.eventPrices !== "undefined") {
          // Deep merge, so prices also absorbs the entry's name/calendarStyle/
          // custom. Read those via resolve.resolveReservationName/Custom —
          // they handle non-merged events and missing variants, this does not.
          timeSlot.event = $.extend(true, {}, timeSlot.event, {
            prices: timeSlot.event.eventPrices.find(function (ep) {
              return ep.eventId === state.event;
            }),
          });
        }

        $.each(event.times, function (dayIndex, day) {
          $.each(day.slots, function (slotIndex, slot) {
            if (slot.time == state.time) {
              timeSlot.data = slot;
              return false;
            }
          });
          if (timeSlot.data !== null) {
            return false;
          }
        });

        return false;
      }
    });

    timeSlot.location = getLocationByVenueId(state.venue);
    timeSlot.room = getRoomByEventId(state.venue, state.event);

    return timeSlot.event === null ? null : timeSlot;
  }

  function getBookings(opt) {
    var deferred = $.Deferred();
    var allDates = st.getAllDates();
    var cfg = ns.config;
    var base = typeof KIOSK_MODE !== "undefined" && KIOSK_MODE ? kioskPath : "/" + site;
    var url = base + "/api/booking/get?start=" + opt.start + "&end=" + (opt.end || opt.start);

    if (opt.venue) {
      url += "&venue=" + opt.venue;
    }
    if (opt.order) {
      url += "&order=" + opt.order;
    }
    if (cfg.isLounge) {
      url += "&lounge=1";
    }
    if (cfg.isLoungeHome) {
      url += "&loungeHome=1";
    }
    if (cfg.isCamp) {
      url += "&camp=1";
    }
    if (cfg.isLocationEvent && cfg.EVENT_NAME) {
      url += "&locationEvent=" + encodeURIComponent(cfg.EVENT_NAME);
    }

    if (opt.useCache && Object.keys(allDates).length > 0) {
      return deferred.resolve(allDates).promise();
    }

    $.get(url)
      .done(function (response) {
        if (!response.success) {
          return deferred.reject(response.message);
        }
        st.mergeDates(response.data);
        if (response.header) {
          $(".booking-header").html(response.header);
        }
        deferred.resolve(response.data);
      })
      .fail(function () {
        return deferred.reject();
      });

    return deferred.promise();
  }

  ns.data = {
    getLocationByVenueId: getLocationByVenueId,
    getRoomByEventId: getRoomByEventId,
    resolveMinPlayersFixedPrice: resolveMinPlayersFixedPrice,
    getSelectedTimeSlot: getSelectedTimeSlot,
    getBookings: getBookings,
  };
})(window.EM.booking);
